import Vue from 'vue'
import { shareOption } from '../lib/config.js'
import request from '@/service'

const CodoonNativeBridge = window.codoonNativeBridge
const bridge = new CodoonNativeBridge()

Vue.prototype.showMsg = function (msg) {
  this.$store.dispatch('playMsg', msg)
}

Vue.prototype.copyWxCode = function (msg) {
  let input = document.querySelector('#wxCode')
  input.select()
  input.setSelectionRange(0, input.value.length)
  if (document.execCommand('copy')) {
    alert('已复制链接到粘贴板')
  } else {
    alert('复制失败，请手动复制')
  }
}

/**
 * 填写地址
 */
Vue.prototype.fillAddress = function (callback) {
  bridge.jumpToAddressManageNew(1875, function () {
    callback && callback()
  })
}

/**
 * 填写地址2
 */
Vue.prototype.fillAddress2 = function (callback) {
  let url = 'https://www.codoon.com/activity/v1/addressmanage2/index.html?eventId=1875'
  bridge.jumpNative({ type: 'webView', value: url }, function () {
    callback && callback()
  })
}

/**
 * 返回
 */
Vue.prototype.goBack = function () {
  window.history.go(-1)
}

/**
 * 跳转到话题
 */
Vue.prototype.goInteractive = function (labelId) {
  window._hmt.push(['_trackEvent', '新加坡航空', 'click', '话题按钮点击'])
  let url = `https://rn.codoon.com/app/rnapp/feed_detail?label_id=${labelId}`
  // jumpToUrl(url, () => {
  // })
  window.open(url)
}

Vue.prototype.goBuy = function (goodId) {
  let url = `codoon://www.codoon.com/mall/goods_detail?goods_id=${goodId}`
  window.location.href = url
  // window.open(url)
}

/**
 * 跳转回APP的URL
 * @param {*} url
 * @param {*} v
 */
Vue.prototype.formatRdUrl = function (url) {
  let rdUrl = ''
  rdUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.codoon.gps&android_scheme=' +
        'codoon://www.codoon.com/outer/web_view?url=' + encodeURIComponent(url) +
        '&ios_scheme=codoon://www.codoon.com/outer/web_view?url=' + encodeURIComponent(url)
  return rdUrl
}

/**
 * 咕咚APP内才执行
 * @param {*} callback
 */
Vue.prototype.inCodoonClick = function (callback) {
  if (bridge.isInCodoon()) {
    callback()
  } else {
    window.location.href = this.formatRdUrl(window.location.href)
  }
}

/**
 * 通用分享
 */
Vue.prototype.commonShare = function () {
  bridge.nativeTopButtonShare({
    sCodoonShareImgUrl: shareOption.img,
    sCodoonShareLineLink: shareOption.link,
    sCodoonShareCodoonLineLink: shareOption.codoonLink,
    sCodoonShareDescContent: shareOption.des,
    sCodoonShareTitle: shareOption.title,
    sCodoonAnalyticsShareSource: '乐活动',
    oCodoonShareDestination: {
      'codoonTimeline': true,
      'codoonGroup': true,
      'weixinToFriend': true,
      'weixinToTimeline': true,
      'sinaWeibo': true,
      'tencentQQ': true,
      'tencentQzone': true
    }
  })
  window._hmt.push(['_trackEvent', '2019华为', 'click', '通用分享按钮点击'])
}

/**
 * 分享回调
 */
Vue.prototype.shareCallBack = function () {
  request.get('share').then(res => {
    this.$store.dispatch('getUserInfo')
  })
}

/**
 * 判定是否为数字(包含小数)
 */
Vue.prototype.isNumber = function (val) {
  let reg = /^[0-9]+.?[0-9]*$/
  return reg.test(val)
}
